var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "enterprise-detail" }, [
    _c("div", { staticClass: "mb-160" }, [
      _c("img", {
        staticClass: "enterprise-detail__img",
        attrs: { src: _vm.item.src, alt: "" },
      }),
      _vm._v(" "),
      _c("p", { staticClass: "enterprise-detail__text" }, [
        _vm._v(_vm._s(_vm.item.text)),
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "enterprise-detail__link",
          attrs: { href: _vm.item.url },
        },
        [_vm._v(_vm._s(_vm.item.name))]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "enterprise-detail__products " }, [
      _c("h2", [_vm._v("Продукция")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "enterprise-detail__products-list" },
        _vm._l(_vm.item.products, function (product, id) {
          return _c(
            "div",
            {
              key: id,
              staticClass: "enterprise-detail__products-item position-relative",
            },
            [
              _c("img", {
                staticClass: "enterprise-detail__products-img",
                attrs: { src: product.src, alt: product.name },
              }),
              _vm._v(" "),
              _c("h3", { staticClass: "enterprise-detail__products-name" }, [
                _vm._v(_vm._s(product.name)),
              ]),
              _vm._v(" "),
              _c("a", {
                staticClass: "enterprise-detail__products-link",
                attrs: { href: product.url },
              }),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }